module.exports = __webpack_public_path__ + "static/media/hn.b2aaded8.svg";